import {call, put, takeEvery} from 'redux-saga/effects';
import * as type from '../../types';
import {changepasswordApi} from '../../api/business/ChangePasswordApi';
import { notification } from 'antd'; 

function* fetchChangePasswordSaga(action){
    try {
        const data = yield call(changepasswordApi, action.payload);
        yield put({type: type.CHANGE_PASSWORD_SUCCESS, data});
        if (action.payload.onSuccess) {
            action.payload.onSuccess();
          }
        yield call(notification.success, {
            message: 'Success',
            description: 'Password changed successfully!',
          });
    } catch (error) {
        yield put({type: type.CHANGE_PASSWORD_FAILURE, message: error.message})
        yield call(notification.error, {
            message: 'Error',
            description: 'Failed to change password.',
          });
    }
}

export function* watchChangePasswordSaga() {
     yield takeEvery(type.CHANGE_PASSWORD_REQUEST, fetchChangePasswordSaga);
}